import * as React from 'react';
import App from './screens/App';
import ReactDOM from 'react-dom';

import keycloak from 'services/keycloak';
import { ReactKeycloakProvider } from '@react-keycloak/web';

import { Provider } from 'react-redux';
import configureStore from 'redux/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import theme, { GlobalStyle } from 'styles';
import i18n from './i18n';
import './plugins-styles.css';

if (process.env.NODE_ENV !== 'production') {
  // const { whyDidYouUpdate } = require('why-did-you-update');
  // whyDidYouUpdate(React);
}

// Redux setup
const { store, persistor } = configureStore();

// Renders the application (inside the div that has the id #root)
const mountNode = document.querySelector('#root');

ReactDOM.render(
  <ReactKeycloakProvider authClient={keycloak}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider theme={theme}>
            <App />
            <GlobalStyle />
          </ThemeProvider>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  </ReactKeycloakProvider>,
  mountNode
);
